/**
 * AG Grid Enterprise — central registration with optional licence key.
 *
 * Provides pivot, grouping, set-filter, range selection, and aggregation
 * features for the moderation heatmap and pivot tables in evaluation results.
 *
 * Without REACT_APP_AG_GRID_LICENCE the grid will run with a small watermark
 * in development. Production deployments should supply the key.
 */
import { LicenseManager } from 'ag-grid-enterprise';
import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';

ModuleRegistry.registerModules([AllEnterpriseModule]);

const licenceKey = process.env.REACT_APP_AG_GRID_LICENCE;
if (licenceKey) {
  LicenseManager.setLicenseKey(licenceKey);
}

export const isEnterpriseLicenced = Boolean(licenceKey);
